const initialiseUpbeFooter = (footer) => {
  if (!footer || footer.dataset.upbeFooterReady === 'true') return;

  footer.dataset.upbeFooterReady = 'true';
  footer.classList.add('is-enhanced');

  footer.querySelectorAll('[data-upbe-footer-accordion]').forEach((button) => {
    const content = document.getElementById(button.getAttribute('aria-controls'));
    if (!content || content.dataset.collapsible !== 'true') return;

    const mobileMedia = window.matchMedia('(max-width: 749px)');

    const setExpanded = (expanded) => {
      button.setAttribute('aria-expanded', String(expanded));
      content.hidden = mobileMedia.matches ? !expanded : false;
    };

    const syncBreakpoint = () => {
      content.hidden = mobileMedia.matches ? button.getAttribute('aria-expanded') !== 'true' : false;
    };

    syncBreakpoint();
    button.addEventListener('click', () => setExpanded(button.getAttribute('aria-expanded') !== 'true'));
    mobileMedia.addEventListener('change', syncBreakpoint);
  });
};

const initialiseAllUpbeFooters = (root = document) => {
  root.querySelectorAll('[data-upbe-footer]').forEach(initialiseUpbeFooter);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initialiseAllUpbeFooters());
} else {
  initialiseAllUpbeFooters();
}

document.addEventListener('shopify:section:load', (event) => initialiseAllUpbeFooters(event.target));
document.addEventListener('shopify:block:select', (event) => {
  const block = event.target.closest('[data-upbe-footer-block]');
  const button = block?.querySelector('[data-upbe-footer-accordion]');
  const content = button && document.getElementById(button.getAttribute('aria-controls'));

  if (button && content) {
    button.setAttribute('aria-expanded', 'true');
    content.hidden = false;
  }
});
